package br.com.vvrefeicoes.portal.core.ui.theme

import androidx.compose.material3.lightColorScheme
import androidx.compose.ui.graphics.Color

object AppPalette {
    /**
     * Fundo de itens selecionados em menus laterais, badges de status neutro.
     */
    val Primary100 = Color(0xFFE0F2F7)

    /**
     * Cor principal: Botões de ação (Salvar, Enviar), links ativos, cabeçalhos.
     */
    val Primary500 = Color(0xFF005F73)

    /**
     * Estados de hover (passar o mouse) em botões primários, títulos de alto impacto.
     */
    val Primary900 = Color(0xFF003B4A)

    /**
     * Fundo claro para badges.
     */
    val Accent100 = Color(0xFFF4F9E6)

    /**
     * Destaque: Ícones ativos, indicadores de progresso, notificações de novidade. Use com moderação.
     */
    val Accent500 = Color(0xFFA5CD39)

    /**
     * Texto sobre verde limão
     */
    val Accent900 = Color(0xFF556F0F)

    /**
     * Fundo de cards, modais, caixas de diálogo.
     */
    val Neutral0 = Color(0xFFFFFFFF)

    /**
     * Fundo geral das páginas (evita fadiga visual).
     */
    val Neutral50 = Color(0xFFF8F9FA)

    /**
     * Linhas divisórias de tabelas, bordas de inputs, separadores.
     */
    val Neutral200 = Color(0xFFDEE2E6)

    /**
     * Textos secundários, legendas, placeholders de formulários, ícones inativos.
     */
    val Neutral500 = Color(0xFF6C757D)

    /**
     * Textos principais, títulos, dados em tabelas. (Alto contraste).
     */
    val Neutral900 = Color(0xFF212529)

    /**
     * Fundo claro para containers de sucesso.
     */
    val Success100 = Color(0xFFD1E7DD)

    /**
     * Mensagens de "Pedido aprovado", "Cadastro concluído".
     */
    val Success500 = Color(0xFF2E7D32)

    /**
     * Texto para containers de sucesso.
     */
    val Success900 = Color(0xFF0F5132)

    /**
     * Fundo claro para containers de alerta.
     */
    val Warning100 = Color(0xFFFFF3CD)

    /**
     * "Estoque baixo", "Atenção à validade", avisos que não impedem a ação.
     */
    val Warning500 = Color(0xFFF59E0B)

    /**
     * Texto para containers de alerta.
     */
    val Warning900 = Color(0xFF664D03)

    /**
     * Fundo claro para containers de erro.
     */
    val Error100 = Color(0xFFF8D7DA)

    /**
     * "Erro ao salvar", "Login incorreto", botões de exclusão.
     */
    val Error500 = Color(0xFFDC3545)

    /**
     * Texto para containers de erro.
     */
    val Error900 = Color(0xFF721C24)

    /**
     * Fundo claro para containers de informação.
     */
    val Info100 = Color(0xFFCFF4FC)

    /**
     * Mensagens informativas, "Novidade no portal", dicas de sistema.
     */
    val Info500 = Color(0xFF0DCAF0)

    /**
     * Texto para containers de informa��ǜo.
     */
    val Info900 = Color(0xFF055160)

    /**
     * Destaque complementar para indicadores que nǜo devem competir com o primary.
     */
    val Purple100 = Color(0xFFEDE7F6)

    /**
     * Cor de destaque para conteúdos em vídeo.
     */
    val Purple500 = Color(0xFF9C27B0)

    /**
     * Texto/ícone sobre o destaque complementar.
     */
    val Purple900 = Color(0xFF4A148C)
}

val AppLightColors =
    lightColorScheme(
        primary = AppPalette.Primary500,
        onPrimary = AppPalette.Neutral0,
        primaryContainer = AppPalette.Primary100,
        onPrimaryContainer = AppPalette.Primary900,
        secondary = AppPalette.Neutral500,
        onSecondary = AppPalette.Neutral0,
        secondaryContainer = AppPalette.Neutral200,
        onSecondaryContainer = AppPalette.Neutral900,
        tertiary = AppPalette.Accent500,
        onTertiary = AppPalette.Neutral900,
        tertiaryContainer = AppPalette.Accent100,
        onTertiaryContainer = AppPalette.Accent900,
        background = AppPalette.Neutral50,
        onBackground = AppPalette.Neutral900,
        surface = AppPalette.Neutral0,
        onSurface = AppPalette.Neutral900,
        surfaceVariant = AppPalette.Neutral200,
        onSurfaceVariant = AppPalette.Neutral500,
        outline = AppPalette.Neutral500,
        outlineVariant = AppPalette.Neutral200,
        error = AppPalette.Error500,
        onError = AppPalette.Neutral0,
        errorContainer = AppPalette.Error100,
        onErrorContainer = AppPalette.Error900,
    )
